<script lang="ts">

  import { page } from "$app/state"
  import { ErrorActionPage, ErrorStatusPage } from "$lib/components/page"
</script>

<svelte:head>
  <title>Error {page.status}</title>
</svelte:head>


{#if page.status == 404}
  <ErrorStatusPage
    title="Halaman tidak ditemukan"
    message="Halaman yang anda cari tidak ditemukan"
  />
{:else if page.status == 403}
  <ErrorStatusPage
    title="Tidak ada akses"
    message="Anda tidak memiliki akses ke halaman ini"
  />
{:else if page.status == 500}
  <ErrorActionPage
    message="Halaman gagal dimuat. Silakan coba lagi"
    useActionReload={true}
  />
{:else}
  <ErrorActionPage
    message={page.error?.message || "Halaman gagal dimuat. Silakan coba lagi"}
    useActionReload={true}
  />
{/if}
